'use client';

import '@/styles/global.css';
import { Suspense } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { ModalProvider } from '@/components/modals'; // export const metadata: Metadata = {
import SupportSpeedDial from '@/components/global/SupportSpeedDial';
import AttributionCapture from '@/components/AttributionCapture';
import MicrosoftClarity from '@/components/analytics/MicrosoftClarity';

// export const metadata: Metadata = {
//   icons: [
//     {
//       rel: 'apple-touch-icon',
//       url: '/apple-touch-icon.png',
//     },
//     {
//       rel: 'icon',
//       type: 'image/png',
//       sizes: '32x32',
//       url: '/favicon-32x32.png',
//     },
//     {
//       rel: 'icon',
//       type: 'image/png',
//       sizes: '16x16',
//       url: '/favicon-16x16.png',
//     },
//     {
//       rel: 'icon',
//       url: '/favicon.ico',
//     },
//   ],
// };
export default function RootLayout(props: {
  children: React.ReactNode;
  params: { locale: string };
}) {
  // Validate that the incoming `locale` parameter is valid
  // if (!AppConfig.locales.includes(props.params.locale)) notFound();

  // Using internationalization in Client Components
  // const messages = useMessages();

  return (
    <html lang={props.params.locale}>
      <body className="bg-white font-sans">
        {/* <NextIntlClientProvider
              locale={props.params.locale}
              messages={messages}
            > */}
        <Suspense fallback={null}>
          <AttributionCapture />
        </Suspense>
        <ModalProvider>
          <div className="min-h-screen">{props.children}</div>
        </ModalProvider>
        {/* </NextIntlClientProvider> */}
        <MicrosoftClarity />
        <Toaster />
        <SupportSpeedDial />
      </body>
    </html>
  );
}

// Enable edge runtime but you are required to disable the `migrate` function in `src/libs/DB.ts`
// Unfortunately, this also means it will also disable the automatic migration of the database
// And, you will have to manually migrate it with `drizzle-kit push`
// export const runtime = 'edge';
